import type { WorldSnapshot } from './protocol.js';

/** Game seconds in which a world's visual events still belong to its opening rather than to history. */
export const OPENING_SECONDS = 1;

/**
 * The last visual event a viewer's first snapshot should treat as already seen. A joiner skips history, except in a world
 * that has only just begun (a fresh scenario room engaging on its first tick), whose opening cues are still news.
 */
export function firstUnseenEvent(snapshot: Pick<WorldSnapshot, 'gameTime' | 'visualEvents'>): number {
  return snapshot.gameTime < OPENING_SECONDS ? 0 : snapshot.visualEvents.at(-1)?.id ?? 0;
}
